// API for testing or Development

const browserDomain = window.location.origin;

let API_Root_Lambda;

if (browserDomain.includes("localhost")){
    // API_Root = "http://127.0.0.1:8000/";
    // USE THIS FOR LOCAL DEV
    API_Root_Lambda ="http://127.0.0.1:8000/"
    // API_Root_Lambda = "https://6gi3x2gv8k.   execute-api.us-east-1.amazonaws.com/";
    // API_Root_Lambda = "https://6gi3x2gv8k.execute-api.us-east-1.amazonaws.com/";
}
else{
    API_Root_Lambda = "https://6gi3x2gv8k.execute-api.us-east-1.amazonaws.com/";
}


export default API_Root_Lambda